import { lazyRetry } from '@lmt/unicorn-shared/app/helpers/retry-helper';

export const MonacoExpressionBuilder = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "MonacoExpressionBuilder" */ './MonacoExpressionBuilderNonLazy'
    ),
);
